import gql from 'graphql-tag';

const WDT_OVERALL_ERROR_QUERY = gql`
  query wdtOverallErrorsReport(
    $where: WdtOverallErrorsReportWhereInput!
    $dateRange: DateRangeInput
  ) {
    wdtOverallErrorsReport(where: $where, dateRange: $dateRange) {
      errors {
        type
        count
      }
    }
  }
`;

export default WDT_OVERALL_ERROR_QUERY;
